import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Fragment } from 'react';
import { Checkbox, Heading, Paragraph } from '@digdir/designsystemet-react';

import { OppvarmingFormData } from '../../../types';
import { CheckedContentWrapper, LeftBorderedContent } from '../common/styledComponents';
import { useOppvarmingValidation } from '../../hooks/useOppvarmingValidation';
import { oppvarmingSelectionFields } from '../../utils';

import { Varmesystem } from './varmesystem';

export const Solfanger = () => {
  const { register, watch, formState } = useFormContext<OppvarmingFormData>();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming.solfanger' });
  const { validateOppvarmingSelection } = useOppvarmingValidation();

  const solfangerSelected = watch('solfanger.selected');

  return (
    <Fragment>
      <Checkbox
        aria-invalid={!!formState.errors.solfanger?.selected}
        label={t('label')}
        {...register('solfanger.selected', {
          validate: validateOppvarmingSelection,
          deps: oppvarmingSelectionFields,
          shouldUnregister: true
        })}
      />

      {solfangerSelected && (
        <CheckedContentWrapper>
          <LeftBorderedContent>
            <Heading level={3} data-size="2xs">
              {t('heading')}
            </Heading>
            <Paragraph>{t('description')}</Paragraph>
          </LeftBorderedContent>

          <Varmesystem />
        </CheckedContentWrapper>
      )}
    </Fragment>
  );
};
